/* "Frequently Bought Together": fetches Shopify's complementary-product
   recommendations and replaces the section's shell with the rendered
   result, the same technique as recommendations.js. Once the real markup
   is in place this also drives the running total and the multi-item add
   to cart, both scoped to whichever bundle is on the page rather than
   assuming there's only one. */
(function () {
  var roots = document.querySelectorAll('[data-bundle]');
  if (!roots.length) return;

  function load(root) {
    var base = root.getAttribute('data-url');
    var id = root.getAttribute('data-product-id');
    if (!base || !id) return;

    var sectionId = root.closest('[id^="shopify-section-"]');
    if (!sectionId) return;

    var url =
      base +
      '?section_id=' +
      encodeURIComponent(sectionId.id.replace('shopify-section-', '')) +
      '&product_id=' +
      encodeURIComponent(id) +
      '&limit=' +
      encodeURIComponent(root.getAttribute('data-limit') || 2) +
      '&intent=complementary';

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Bundle unavailable');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-bundle]');

        // No complementary products set for this product is a normal
        // outcome — the section just doesn't show rather than rendering
        // an empty box.
        if (!next || !next.querySelector('[data-bundle-item]')) {
          root.remove();
          return;
        }

        root.innerHTML = next.innerHTML;
        bind(root);
      })
      .catch(function () {
        root.remove();
      });
  }

  function bind(root) {
    var addButton = root.querySelector('[data-bundle-add]');
    var totalEl = root.querySelector('[data-bundle-total]');

    function recalc() {
      var total = 0;

      root.querySelectorAll('[data-bundle-row]').forEach(function (row) {
        var checkbox = row.querySelector('[data-bundle-item]');
        var select = row.querySelector('[data-bundle-variant-select]');
        row.classList.toggle('is-excluded', !checkbox.checked);
        if (!checkbox.checked) return;

        var price = select
          ? parseInt(select.options[select.selectedIndex].getAttribute('data-price'), 10)
          : parseInt(checkbox.getAttribute('data-price'), 10);

        total += price;
      });

      if (totalEl) totalEl.textContent = formatMoney(total);
    }

    // The theme has no access to the shop's money_format string here —
    // this reuses whatever currency symbol Liquid already printed for the
    // first item's price rather than guessing one, since it's already on
    // the page and always correct for the shop.
    function formatMoney(cents) {
      var sample = root.querySelector('[data-bundle-item-price]');
      var symbolMatch = sample && sample.textContent.match(/^\s*([^\d\s]+)/);
      var symbol = symbolMatch ? symbolMatch[1] : '$';
      return symbol + (cents / 100).toFixed(2);
    }

    root.querySelectorAll('[data-bundle-item]').forEach(function (checkbox) {
      checkbox.addEventListener('change', recalc);
    });

    root.querySelectorAll('[data-bundle-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var checkbox = select.closest('[data-bundle-row]').querySelector('[data-bundle-item]');
        checkbox.setAttribute('data-variant-id', select.value);
        checkbox.setAttribute('data-price', select.options[select.selectedIndex].getAttribute('data-price'));
        recalc();
      });
    });

    if (addButton) {
      addButton.addEventListener('click', function () {
        var items = [];

        root.querySelectorAll('[data-bundle-item]:checked').forEach(function (checkbox) {
          items.push({ id: parseInt(checkbox.getAttribute('data-variant-id'), 10), quantity: 1 });
        });

        if (!items.length) return;

        addButton.setAttribute('aria-busy', 'true');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw new Error(data.description || data.message);
              return data;
            });
          })
          .then(function () {
            // The cart drawer owns its own refresh/open sequence — this
            // just asks for it rather than duplicating that logic here.
            var cartLink = document.querySelector('.pb-header__cart');
            if (cartLink) cartLink.click();
            else window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart';
          })
          .catch(function (error) {
            window.alert(error.message);
          })
          .finally(function () {
            addButton.removeAttribute('aria-busy');
          });
      });
    }
  }

  if (!('IntersectionObserver' in window)) {
    roots.forEach(load);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    },
    { rootMargin: '400px 0px' }
  );

  roots.forEach(function (root) {
    observer.observe(root);
  });
})();
